import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../../constants/apiPath";
import axios from "axios";

const initialState = {
  isLoading: false,
  categories: [],
  collections : [],
};
const THUNK_METHODS = {
  CATEGORY_GET: "user/category",
  COLLECTION_GET: "user/collections"
};

export const getCategories = createAsyncThunk(
  THUNK_METHODS.CATEGORY_GET,
  async (args, { rejectWithValue }) => {
    try {
      const {data} = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.CATEGORY.GET}`,
        withCredentials: true,
      });
      return data.categories;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    }
  }
);
export const getCollections = createAsyncThunk(
  THUNK_METHODS.COLLECTION_GET,
  async (gender, { rejectWithValue }) => {
    try {
      const {data} = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.COLLECTION.GET}?gender=${gender}`,
        withCredentials: true,
      });
      return data;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    }
  }
);
export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCategories.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCategories.fulfilled, (state, action) => {
      state.categories = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getCategories.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getCollections.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCollections.fulfilled, (state, action) => {
      state.collections = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getCollections.rejected, (state) => {
      state.isLoading = false;
    });
  },
});
export const { } = categorySlice.actions;
